import BubbleType from "./BubbleType";
import { Constants } from "./Constants";

/**
 * Model class which holds the chat individual message
 * @class
 */
class Message {
    bubbleType: number;

    text: string;

    auto: boolean;

    _name: string;

    _timestamp: number;

    _persistInTranscript: boolean;

    _agentIndex: number;

    _isLast: boolean;

    samePreviousType: any;

    restore: any;

    _state: any;

    _richData: any;

    _richInstance: any;

    _richMediaDisplay: boolean;

    externalVA: boolean;

    constructor({ bubbleType = BubbleType.AGENT_MESSAGE, messageText = "", isAuto = false, name = "", timestamp = Date.now(), richMediaDisplay= false }: any = {}) {
        /**
         * @type {BubbleType}
         * @private
         */
        this.bubbleType = bubbleType;

        /**
         * chat text
         * @type {string}
         * @private
         */
        this.text = messageText.replace(/\n\r?/g,"<br/>");

        /**
         * is virtual agent message
         * @type {boolean}
         * @private
         */
        this.auto = isAuto;

        /**
         * customer or agent name
         * @type {string}
         * @private
         */
        this._name = name;

        /**
         * message timestamp
         * @type {number}
         * @private
         */
        this._timestamp = timestamp;

        /**
         * message richMediaDisplay
         * @type {boolean}
         * @private
         */
        this._richMediaDisplay = richMediaDisplay;

        /**
         * does the message should always be in transcript, typing messages will be removed upon a new agent or customer or system message
         * @type {boolean}
         * @private
         */
        this._persistInTranscript = !!BubbleType.TYPING_MESSAGE;

        this._agentIndex = 0;

        this._isLast = false;

        this.externalVA = false;
    }

    /**
     *
     * @param {BubbleType} type
     */
    setMessageBubble(type) {
        this.bubbleType = type;
    }

    /**
     * @returns {BubbleType}
     */
    getMessageBubble() {
        return this.bubbleType;
    }

    /**
     * @returns {string}
     */
    getName() {
        return this._name;
    }

    /**
     * @param {string} name
     */
    setName(name) {
        this._name = name;
    }

    /**
     * @returns {boolean}
     */
    isVA() {
        return this.auto;
    }

    /**
     * @return {void}
     */
    setVA() {
        this.auto = true;
    }

    isExternalVA() {
        return this.externalVA;
    }
    
    setExternalVA() {
        this.externalVA = true;
    }

    /**
     * @return {string}
     */
    getMessageText() {
        return this.text;
    }

    /**
     * @param {string} text
     */
    setMessageText(text) {
        this.text = text.replace(/\n\r?/g,"<br/>");
    }

    /**
     * @return {number}
     */
    getTimeStamp() {
        return this._timestamp;
    }

    /**
     * @param {number} timestamp
     */
    setTimeStamp(timestamp) {
        this._timestamp = timestamp;
    }

    /**
     * @return {boolean}
     */
    getRichMediaDisplay() {
        return this._richMediaDisplay;
    }

    /**
     * @param {boolean} richMediaDisplay
     */
    setRichMediaDisplay(richMediaDisplay) {
        this._richMediaDisplay = richMediaDisplay;
    }

    /**
     * @param {boolean} sameType
     */
    setSamePreviousType(sameType) {
        this.samePreviousType = sameType;
    }

    /**
     * @return {boolean}
     */
    isSamePreviousType() {
        return this.samePreviousType || false;
    }

    /**
     * Is this message rendering when chat window is restored after a page refresh
     * @param {boolean} val
     */
    setRestore(val) {
        this.restore = val;
    }

    /**
     * @return {boolean}
     */
    getIsRestore() {
        return this.restore;
    }

    setIsLast(val) {
        this._isLast = val;
    }

    isLast() {
        return this._isLast;
    }

    /**
     * @param {boolean} state
     */
    persistInTranscript(state) {
        this._persistInTranscript = state;
    }

    /**
     * @return {boolean}
     */
    getPersistInTranscriptState() {
        return this._persistInTranscript;
    }

    /**
     * @param {SYSTEM_STATE} val
     */
    setInternalState(val) {
        this._state = val;
    }

    /**
     * @param {SYSTEM_STATE} val
     */
    setTypingState(val) {
        this._state = val;
    }

    /**
     * If it is a system message then
     * @return {SYSTEM_STATE}
     */
    getInternalState() {
        return this._state;
    }

    /**
     * @param {Object} data - rich widget data
     */

    setRichData(data) {
        this._richData = data;
    }

    /**
     * returns rich widget data
     * @return {Object}
     */
    getRichData() {
        return this._richData;
    }

    /**
     *
     * @param {RichMain} inst
     */
    setRichInstance(inst) {
        this._richInstance = inst;
    }

    getRichInstance() {
        return this._richInstance;
    }

    setAgentIndex(index) {
        this._agentIndex = index;
    }

    getAgentIndex() {
        return this._agentIndex;
    }

    isEmptyResponse() {
        return this.text === Constants.EA;
    }
}

export default Message;
